<template>
  <v-container class="login-wrapper pa-0" fluid>
    <div class="login-wallpaper">
      <v-img :src="cvcIcon" contain width="600px" height="600px"/>
    </div>
    <v-row class="mb-5 mt-12">
      <span class="mx-auto font-size-gigantic font-weight-medium  text--colorPrimary1">Covatic Insights</span>
    </v-row>
    <v-row class="mb-2">
      <span class="mx-auto text--colorPrimary1">{{greeting}}</span>
    </v-row>
    <v-row v-if="!!$slots.errors">
      <span class="mx-auto red--text"><slot name="errors"/></span>
    </v-row>
    <v-row v-if="!!$slots.info">
      <span class="mx-auto green--text"><slot name="info"/></span>
    </v-row>
    <v-row>
      <span class="mx-auto"><slot name="form"/></span>
    </v-row>
    <v-row class="external-links">
      <span class="mx-auto">
        <a href="https://www.covatic.com/terms" target="_blank">Terms of Use</a> |
        <a href="https://www.covatic.com/terms" target="_blank">Privacy Policy</a>
      </span>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'LoginWrapper',
  props: {
    greeting: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      cvcIcon: require('../../assets/Covatic_Logomark - Full color.png'),
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/styles/_colors.scss";

  .login-wrapper {
    height: 100% !important;
    width: 600px !important;
  }

  .login-wallpaper {
    position: fixed;
    z-index: -1;
    opacity: 0.4;
    transform: translate(0, -170px);
  }

  .errors {
    background-color: $orange-800;
    color: $white;
    padding: 1em;
    margin: 0 0 0.7em;
    a {
      color: $white;
      text-decoration: underline;
    }
  }
  .info {
    background-color: $green-900;
    color: $white;
    padding: 1em;
    margin: 0 0 0.7em;
    a {
      color: $white;
      text-decoration: underline;
    }
  }
  .external-links {
    margin-top: 100px;
    a {
      color: $purple-900;
    }
  }
</style>